import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {ConfirmationService} from '~/app/core/common/services/confirmation.service';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {NotificationsComponent} from '~/app/web/components/notifications/notifications.component';
import {Router} from '@angular/router';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {KeycloakHelper} from '~/app/shared/helpers/keycloak-helper';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {MenuService} from 'mclane-apptemplate-lib';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {CookieManagementService, JwtService, OauthService} from 'mclane-webauth-lib';
import {CookieService} from 'ngx-cookie-service';
import {InvoicelistDialogComponent} from "~/app/web/components/invoicelist-dialog/invoicelist-dialog.component";
import {ToastService} from '~/app/shared/helpers/toast-service';
import {LoadingIndicatorHelper} from "~/app/shared/helpers/loading-indicator-helper";

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnChanges, OnDestroy {
    public eventSub: Subscription;
    @Input() menuItemList: Observable<any[]>;
    @Input() customerId: number;
    @Input() confirmationCount: Observable<number>;

    @ViewChild(NotificationsComponent, {static: false})
    dialog: NotificationsComponent;

    @ViewChild(InvoicelistDialogComponent, {static: false})
    invoicelistDialog: InvoicelistDialogComponent;


    menutype: any[] = [{
        text: '',
        separator: true,
        icon: 'bell',
        disabled: true,
        url: '',
        subItems: null,
        class: 'iconOnly'
    },
        {text: 'Home', separator: true, icon: '', disabled: false, textColor: 'green', url: 'home', subItems: null},
        {text: 'Profile', prepend: '', separator: true, icon: '', disabled: false, url: 'profile', subItems: null},
        {text: 'Store List', prepend: '', separator: true, icon: '', disabled: false, url: 'storelist', subItems: null},
    ];

    tempRef: any;

    constructor(private _keycloakHelper: KeycloakHelper,
                private _applicationSettingsHelper: ApplicationSettingsHelper,
                public dialogHelper: DialogHelperComponent,
                public confirmationService: ConfirmationService,
                public router: Router,
                private configuration: ConfigurationService,
                public menuservice: MenuService,
                public storeListService: StoreListService,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                public jwtService: JwtService,
                public cookieService: CookieService,
                public cookieMclane: CookieManagementService,
                public oauthService: OauthService,
                private toaster: ToastService,
                private _loadingIndicatorHelper: LoadingIndicatorHelper
    ) {

    }

    async ngOnInit() {
        this.eventSub = this.menuservice.eventRan.subscribe((result) => {
            this.ClickedItem(result);
        });
        if (this.customerId !== 0 && this.customerId != null && this.customerId.toString() !== '') {
            await this.confirmationService.getStoreConfirmation();
        }
    }

    ngOnDestroy(): void {
        this.eventSub.unsubscribe();
    }

    async logoutClicked() {
        // TODO test if this is needed
        // this.storeListService.storeList = [];
        // this.storeListService.storeList = undefined;
        localStorage.clear();
        this.oauthService.logoutOfApplication('');
    }

    async openconfirmations($event: MouseEvent) {
        await this.dialogHelper
            .showNotificationDialog(this.dialog).then(results => {

            });

    }

    async ngOnChanges(changes: SimpleChanges) {
        if (this.customerId !== 0 && this.customerId != null && this.customerId.toString() !== '') {
            await this.confirmationService.getStoreConfirmation();
        }
    }

    showInvoiceSelectDialog() {
        this._loadingIndicatorHelper.show('')
        this.storeListService.getInvoicesForCustId(
            this.storeListService.pickedChain,
            this.storeListService.pickedCustomerNumber,
            this.storeListService.pickedSrcSystem).then(result =>{
             this._loadingIndicatorHelper.hide()
             if (this.storeListService.invoiceList !== undefined && this.storeListService.invoiceList.length > 0) {
                this.dialogHelper.showInvoiceDialog(this.tempRef, this.invoicelistDialog, this.storeListService.invoiceList).then(r => r);
            } else {
                this.toaster.showToastWarning('No Invoices for ' + this.storeListService.pickedStore.identity, '', 3500)
            }
            });
    }

    ClickedItem($event) {
        switch ($event.text) {
            case 'Invoices':
                this.showInvoiceSelectDialog();
                break;
            case 'Logout':
                this.logoutClicked().then(() => {
                });
                break;
            case '':
                this.openconfirmations($event).then(() => {
                });

        }
    }
}
